import 'css-chunksrc/client/scenes/wbs/milestone/milestoneCompletion/styles.scss';export default {
  "icon": "_icon_1gwap_1",
  "completed": "_completed_1gwap_9",
  "input": "_input_1gwap_13",
  "listRoot": "_listRoot_1gwap_28",
  "list": "_list_1gwap_28",
  "item": "_item_1gwap_49",
  "name": "_name_1gwap_56",
  "doneName": "_doneName_1gwap_62",
  "open": "_open_1gwap_66",
  "done": "_done_1gwap_62",
  "readOnly": "_readOnly_1gwap_84"
};